/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { TableBeneficiaries } from '../../components/TableBeneficiaries';
import { LoadingSkeleton } from '../../components/LoadingSkeleton';

import { useBeneficiariesDataContextStorage } from '../../contexts/BeneficiariesDataContext';
import { useBeneficiariesData } from '../../hooks/useBeneficiariesData';
import useFilterData from '../../hooks/useFilterData';
import { CorporateClub } from '../../contexts/types/corpclub-type';


const CorpClubBeneficiaries = () => {
  const {
    states: {
      beneficiariesData: { getter: beneficiariesData },
    },
  } = useBeneficiariesDataContextStorage() as any;

  const { getBeneficiariesCorpClub } = useBeneficiariesData();

  const [completeCorporateClubList, setCompleteCorporateClubList] = useState ([] as CorporateClub[]);

  const {
    selectedContractedPlan,
    selectedAvailablePlan,
    startInclusionDate,
    endInclusionDate,
    selectedStartDate,
    selectedEndDate,
    startRowNum,
    search,
    filterButtonPressed,
    loading,
  } = useFilterData();

  useEffect(() => {
    getBeneficiariesCorpClub();
  }, [
    selectedContractedPlan,
    selectedAvailablePlan,
    startInclusionDate,
    endInclusionDate,
    selectedStartDate,
    selectedEndDate,
    startRowNum,
    search,
  ]);

  useEffect(() => {
  if (!beneficiariesData) {
    return;
  }
 
  setCompleteCorporateClubList((prev: CorporateClub[]) => {
    const names = new Set(prev.map(b => b.name));
    return [
      ...prev,
      ...beneficiariesData.filter((b: { name: string; }) => !names.has(b.name))
    ];
  });
}, [beneficiariesData]);

  useEffect(() => {
    setCompleteCorporateClubList([]);
  }, [filterButtonPressed]);

  console.log('loding no componente: ', loading);

  return (
    <div className="corporates-club-beneficiaries-body-container" data-testid="main-page-test-id">
      <>{loading ? <LoadingSkeleton /> : <TableBeneficiaries corporateClubList={completeCorporateClubList} />}</>
    </div>
  );
};

export default CorpClubBeneficiaries;
